import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes.ts'

// import Pop, { BUY_TICKET } from 'pages/avia/detail-ticket/components/Pop'
import { FlightInfoOrders } from 'pages/avia/my-ticket/pages/ListPassengers/components/flight-info-orders'

import { groupSegmentsByDirection } from 'entities/tour/libs'
import { prepareFlightDataForInfoOrders } from 'entities/tour/libs/flightData'
import { getRouteInfo } from 'entities/tour/libs/routeInfo'

// import searchTour from 'entities/tour/models/search-tour/search-tour'
import { Flight } from 'shared/api/tours/flights/model'
import { getRawColor } from 'shared/lib/getRawColor.ts'
import { ButtonContinue } from 'shared/ui/bottom-continue'
// import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'
import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

interface FlightDetailsProps {
  selectedFlight: Flight | null
  isViewMode?: boolean
}

export const FlightDetails = observer(
  ({ selectedFlight, isViewMode = false }: FlightDetailsProps) => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    // const { closeDialog, openDialog } = useDialogBottomSheet()

    const transports = selectedFlight?.transport || []

    const segmentsByDirection = groupSegmentsByDirection(transports)
    const allSegments = Object.values(segmentsByDirection).flat()
    const routeInfo = getRouteInfo(allSegments)

    const ticketsDirections = prepareFlightDataForInfoOrders(transports)

    const handleGoBack = () => {
      navigate(-1)
    }

    // const onContinue = (type: BUY_TICKET) => {
    //   searchTour.onBuyForMySelf(type === BUY_TICKET.FOR_MY_SELF)

    //   closeDialog()

    //   navigate(RoutingPaths.tours.clientData.path())
    // }

    const handleNextStep = () => {
      navigate(RoutingPaths.tours.clientData.path())
      // openDialog({
      //   child: <Pop onContinue={onContinue} />,
      //   isDialog: false,
      // })
    }

    return (
      <div>
        <HeaderGoBack
          variant={'white'}
          title={t('detail_flight')}
          arrowColor={getRawColor('--black')}
          onGoBack={handleGoBack}
          buttonWhite
        />

        {selectedFlight && transports && transports.length > 0 && (
          <div className={clsx('container', s.container)}>
            <FlightInfoOrders
              title={routeInfo}
              ticketsDirections={ticketsDirections}
            />

            {!isViewMode && (
              <ButtonContinue
                className="bold-17"
                onClick={handleNextStep}
              >
                {t('tours_block.select_flight')}
              </ButtonContinue>
            )}
          </div>
        )}

        {!selectedFlight && (
          <div className={s.error}>
            {t('tours_block.flight_details_not_found')}
          </div>
        )}

        {selectedFlight && (!transports || transports.length === 0) && (
          <div className={s.error}>{t('tours_block.flight_details_empty')}</div>
        )}
      </div>
    )
  },
)
